/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_Storefront_VisibilityInputs */

const en_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Storefront Visibility`)
};

const es_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar visibilidad de la tienda`)
};

const fr_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer la visibilité de la vitrine`)
};

const de_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeit der Storefront umschalten`)
};

const ja_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントの公開/非公開を切り替える`)
};

const zh_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换店铺可见性`)
};

const ar_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديل ظهور واجهة المتجر`)
};

const id_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alihkan Visibilitas Etalase`)
};

const it_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/Disattiva Visibilità Vetrina`)
};

const ru_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить видимость витрины`)
};

const pt_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar Visibilidade da Vitrine`)
};

const ko_toggle_storefront_visibility = /** @type {(inputs: Toggle_Storefront_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 표시 상태 전환`)
};

/**
* | output |
* | --- |
* | "Toggle Storefront Visibility" |
*
* @param {Toggle_Storefront_VisibilityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const toggle_storefront_visibility = /** @type {((inputs?: Toggle_Storefront_VisibilityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_Storefront_VisibilityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toggle_storefront_visibility(inputs)
	if (locale === "es") return es_toggle_storefront_visibility(inputs)
	if (locale === "fr") return fr_toggle_storefront_visibility(inputs)
	if (locale === "de") return de_toggle_storefront_visibility(inputs)
	if (locale === "ja") return ja_toggle_storefront_visibility(inputs)
	if (locale === "zh") return zh_toggle_storefront_visibility(inputs)
	if (locale === "ar") return ar_toggle_storefront_visibility(inputs)
	if (locale === "id") return id_toggle_storefront_visibility(inputs)
	if (locale === "it") return it_toggle_storefront_visibility(inputs)
	if (locale === "ru") return ru_toggle_storefront_visibility(inputs)
	if (locale === "pt") return pt_toggle_storefront_visibility(inputs)
	return ko_toggle_storefront_visibility(inputs)
});